import { WebPlugin } from '@capacitor/core';
import { AuthPluginPlugin } from '../../definitions';

export class AuthPluginWeb extends WebPlugin implements AuthPluginPlugin {

  constructor() {
    super({
      name: 'AuthPlugin',
      platforms: ['web'],
    });
  }

  async getAuthToken(): Promise<{ authToken?: string }> {
    return {};
  }

  async logout(): Promise<{}> {
    return {};
  }

  async setAuthToken(_: { loginResponse: any; }): Promise<{}> {
    return {};
  }
}
